import React from 'react';
import { useService } from '@xstate/react';
import HvSvg from 'src/components/HvSvg';
import { Direction, LightboxContext } from 'src/machines/lightboxMachine';
import UserAgent from 'src/utils/UserAgent';
import {
  CloseButton,
  DownloadButton,
  Image,
  ImageContainer,
  LightboxContainer,
  Mask,
  NextButton,
  PreviousButton,
} from './styled';

interface LightboxProps {
  exitLightbox: () => {};
  trackDownload: (isEnhanced: boolean) => {};
  lightboxRef: any;
}

const Lightbox: React.FunctionComponent<LightboxProps> = (props) => {
  const { lightboxRef, exitLightbox, trackDownload } = props;
  const [current, send] = useService(lightboxRef);
  const { nextEvents, context } = current as any;

  const hasNext = nextEvents.includes(Direction.NEXT);
  const hasPrevious = nextEvents.includes(Direction.PREVIOUS);
  const { imageData, index } = context as LightboxContext;
  const isIpad = UserAgent.isIpad();

  const { imgUrl: currentImageUrl, enhanced: isEnhanced } = imageData[index];

  return (
    <>
      <LightboxContainer>
        <ImageContainer>
          <PreviousButton
            data-selenium="previousButton"
            size={44}
            onClick={() => send({ type: Direction.PREVIOUS })}
            disabled={!hasPrevious}
          >
            <div>
              <HvSvg
                src={require(`src/assets/icons/${
                  hasPrevious ? 'primary' : 'inactive'
                }-arrow-in-circle.svg`)}
              />
            </div>
          </PreviousButton>
          <Image src={currentImageUrl} />
          <NextButton
            data-selenium="nextButton"
            size={44}
            onClick={() => send({ type: Direction.NEXT })}
            disabled={!hasNext}
          >
            <div>
              <HvSvg
                src={require(`src/assets/icons/${
                  hasNext ? 'primary' : 'inactive'
                }-arrow-in-circle.svg`)}
              />
            </div>
          </NextButton>
          {!isIpad && (
            <DownloadButton size={26} data-selenium="downloadButton">
              <a
                download
                href={currentImageUrl}
                onClick={() => trackDownload(isEnhanced)}
              >
                Download
              </a>
            </DownloadButton>
          )}
        </ImageContainer>
        <CloseButton
          size={16}
          data-selenium="closeLightboxButton"
          onClick={exitLightbox}
        >
          <HvSvg src={require('src/assets/icons/times-small.svg')} />
        </CloseButton>
      </LightboxContainer>
      <Mask onClick={exitLightbox} />
    </>
  );
};

export default Lightbox;
